"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Tab = /** @class */ (function (_super) {
    __extends(Tab, _super);
    function Tab() {
        var _this = _super.call(this) || this;
        _this.renderTitles = _this.renderTitles.bind(_this);
        _this.renderContent = _this.renderContent.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.labels = _this.labels.bind(_this);
        _this.state = {
            selected: 0
        };
        return _this;
    }
    Tab.prototype.handleClick = function (index, event) {
        event.preventDefault();
        this.setState({
            selected: index
        });
    };
    Tab.prototype.labels = function (child, index) {
        var activeClass = (this.state.selected === index ? 'active' : '');
        return (React.createElement("li", { key: index },
            React.createElement("a", { href: "#", className: activeClass, onClick: this.handleClick.bind(this, index) }, child.props.label)));
    };
    Tab.prototype.renderTitles = function () {
        var _this = this;
        if (this.props.children) {
            return (React.createElement("ul", { className: "tabs_labels" }, this.props.children.map(function (child, index) { return _this.labels(child, index); })));
        }
        else {
            return '';
        }
    };
    Tab.prototype.renderContent = function () {
        return (React.createElement("div", { className: "tabs_content" }, this.props.children ? this.props.children[this.state.selected] : ''));
    };
    Tab.prototype.render = function () {
        return (React.createElement("div", { className: "tabs" },
            this.renderTitles(),
            this.renderContent()));
    };
    return Tab;
}(React.Component));
exports.Tab = Tab;
//# sourceMappingURL=Tab.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@abb/common-ux/dist/components/Tab/Tab.js
// module id = 595
// module chunks = 1